
import headerImage from "Utils/Assets/Images/headerImage.png";
import headerImageMob from "Utils/Assets/Images/headerImageMobile.png";

export const homeConfig = {
    underConstruction: false,
    underConstructionMessage: "This page is under construction. Please visit later.",
    SEO_DATA: {
        title: "MeetusVR | Home",
        description: "Discover the latest insights and developments in the metaverse and blockchain technology with MeetusVR. " +
            "Stay informed about virtual reality, decentralized finance, NFTs, and more.",
        keywords: ["MeetusVR", "Metaverse", "Virtual Reality", "VR", "Blockchain", "NFTs", "Decentralized Finance", "DeFi"],
    },
    headerConfig: {
        productValue: "Earn MVR Coins by Chatting, Hosting & Engaging!",
        productValueMob: "Turn Your Time into Earnings with MeetUsVR",
        contentDescription: "Join MeetUsVR, where every conversation, event, and review rewards you in MVR. Get started now and start earning!",
        contentDescriptionMob: "Earn tokens by chatting, gaming, and hosting events.  Build your better financial future today.",
        buttonText: "Download & Start Earning MVR Today!",
        headerImg: headerImage,
        headerImgMob: headerImageMob,
    },
}
